import React from 'react';
import {Grid} from "@material-ui/core";
import InputField from "../../../FormikUtils/InputField";

function PassphraseForm(props) {
    const {formField: {password}} = props;

    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                    <InputField type="password" name={password.name} label={password.label} fullWidth/>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

export default PassphraseForm;